@if (isLoading()) {
  <nk-progress [isLoading]="true"></nk-progress>
}

@if (screeningCaseReviewCompositeEntity(); as reviewComposite) {
  <nk-screening-case-review-form
    [screeningCaseComposite]="screeningCaseComposite()"
    [screeningCaseReviewCompositeEntity]="reviewComposite"
    [disabled]="isReviewComplete()"
    [severalMatches]="severalMatches()"
    [showActions]="true"
    [screeningConfigUuid]="screeningConfigUuid()"
    [screeningCaseReviewStatusList]="screeningCaseReviewStatusList()"
    [isReviewComplete]="isReviewComplete()"
    [reviewerEmail]="reviewerEmail()"
    (reviewSaved)="onReviewSaved()"
    (reviewCreated)="onReviewCreated()"></nk-screening-case-review-form>
} @else if (!isLoading()) {
  <p class="text-muted">{{ 'screening.case.review.initializing' | translate }}</p>
}
